<template>
  <el-dialog :title="`${!id ? '添加' : '编辑'}分类导航`" :visible.sync="modalShow" width="600px">
    <el-form :model="editeForm" ref="editeForm" :rules="rules" size="small" label-width="110px">
      <el-form-item label="分类导航名称" prop="className">
        <el-input v-model.trim="editeForm.className" maxlength="100" placeholder="分类导航名称" />
      </el-form-item>
      <el-form-item label="排序号" prop="sortNum">
        <el-input v-model.trim="editeForm.sortNum" maxlength="10" placeholder="排序号" @input="(value)=>editeForm.sortNum = value.replace(/[^\d]/g, '')"/>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="modalShow = false">取 消</el-button>
      <el-button type="primary" @click="submit('editeForm')" :loading="submitLoading">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { fenleiApi } from "../api"
export default {
  data () {
    return {
      modalShow: false,
      rules: {
        className: [{ required: true, message: '请输入分类导航名称', trigger: 'blur' }],
        sortNum: [{ required: true, message: '请输入排序号', trigger: 'blur' }]
      },
      editeForm: {
        className: "",
        sortNum: ""
      },
      submitLoading: false,
      id: null
    }
  },
  watch: {
    modalShow: {
      handler (value) { if (!value) { this.$refs['editeForm'].resetFields() } },
    }
  },
  methods: {
    init (row) {
      if (row && row.id) {
        this.id = row.id
        this.getDetail(this.id)
      } else {
        this.id = null
      }
      this.modalShow = true
    },
    async getDetail (id) {
      const res = await fenleiApi.getActivitySpClass({ id })
      if (res.code !== 0) return;
      const { data } = res || {}
      for (const key in this.editeForm) {
        if (data[key] ?? false) {
          this.editeForm[key] = data[key]
        }
      }
    },
    async submit (formName) {
      const params = { ...this.editeForm }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(!this.id){
            this.addData(params)
          }else{
            params.id = this.id
            this.updataData(params)
          }
        } else {
          return false;
        }
      });
    },
    async addData (params) {
      const res = await fenleiApi.addActivitySpClass(params)
      if (res.code !== 0) return;
      this.$message.success('操作成功！')
      this.modalShow = false
      this.$refs['editeForm'].resetFields()
      this.$bus.$emit('update', true)
    },
    async updataData(params){
      const res = await fenleiApi.updateActivitySpClass(params)
      if (res.code !== 0) return;
      this.$message.success('更新成功！')
      this.modalShow = false
      this.$refs['editeForm'].resetFields()
      this.$bus.$emit('update', true)
    }
  }
}
</script>

<style>
</style>